import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import {
  MEESHO_DASHBOARD,
  MEESHO_BULK_IMPORT,
  MEESHO_ORDERS_LIST,
  MEESHO_RTO,
  MEESHO_REPORT,
  MEESHO_PAYMENT_IMPORT,
} from "app/routes/constant";

const MeeshoMenu = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Dashboard",
      icon: "material-symbols:dashboard",
      route: MEESHO_DASHBOARD,
      color: "#E91E63", // Brand Pink
      description: "View your Meesho dashboard overview",
    },
    {
      title: "Orders Import",
      icon: "material-symbols:deployed-code-update",
      route: MEESHO_BULK_IMPORT,
      color: "#9C27B0", // Royal Purple
      description: "Import orders in bulk from Meesho",
    },
    {
      title: "Report",
      icon: "material-symbols:analytics",
      route: MEESHO_REPORT,
      color: "#F44336", // Vibrant Red
      description: "Generate and view reports",
    },
    {
      title: "Invoices List",
      icon: "material-symbols:list-alt",
      route: MEESHO_ORDERS_LIST,
      color: "#009688", // Teal Green
      description: "Manage and view all your Invoices",
    },
    {
      title: "RTO",
      icon: "material-symbols:assignment-return",
      route: MEESHO_RTO,
      color: "#FF9800", // Amber Orange
      description: "Return to Origin management",
    },
    {
      title: "Payment (Remittance) Import",
      icon: "material-symbols:payment-arrow-down",
      route: MEESHO_PAYMENT_IMPORT,
      color: "#3F51B5", // Indigo Blue
      description: "Import payment in bulk from Meesho",
    },
  ];

  const handleMenuClick = (route) => {
    navigate(route);
  };

  return (
    <Box>
      <Typography variant="h3" sx={{ mb: 3, fontWeight: "bold" }}>
        Meesho Management
      </Typography>

      <Grid container spacing={3}>
        {menuItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                },
                border: `2px solid ${item.color}20`,
                borderRadius: 2,
              }}
              onClick={() => handleMenuClick(item.route)}
            >
              <CardContent sx={{ textAlign: "center", p: 3 }}>
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    backgroundColor: `${item.color}15`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px auto",
                    border: `3px solid ${item.color}30`,
                  }}
                >
                  <Icon
                    icon={item.icon}
                    style={{
                      fontSize: "40px",
                      color: item.color,
                    }}
                  />
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: item.color,
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  {item.description}
                </Typography>

                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: item.color,
                    "&:hover": {
                      backgroundColor: item.color,
                      opacity: 0.8,
                    },
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  startIcon={<Icon icon="material-symbols:arrow-forward" />}
                >
                  Open {item.title}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MeeshoMenu;
